import './App.css';
import { useState, useEffect, useRef } from 'react';
import Header from './components/Header';
import ChatArea from './components/ChatArea';
import Prompt from './components/Prompt';
import Login from './components/Auth';
import { ConversationAPI } from './apis/conversation/ConversationAPI';

import './App.css';

function App() {

  const [chatHistoryLog, setChatHistoryLog] = useState([]);
  const [conversationId, setConversationId] = useState('');
  const [fetchingAwnser, setFetchingAwnser] = useState(false);
  const [conversationStarted, setConversationStarted] = useState(false);

  
  const startConversation = () => {
    ConversationAPI.startConversation()
      .then((id) => {
        window.sessionStorage.setItem('conversationId', id);
        setConversationId(id);
      })
      .catch((error) => {
        if (error) {
          //console.log(error.toJSON());
        }
      });
  }

  useEffect(() => {
    if (!window.localStorage.getItem('password') || 
        !window.localStorage.getItem('country') || 
        !window.localStorage.getItem('storeId') ||
        !window.sessionStorage.getItem('conversationId')) {
          setConversationStarted(false);
    } else {
      setConversationStarted(true);
    }
  }, [conversationId]);

  const abortControllerRef = useRef(new AbortController());

  const clearChatLog = function () {
    const abortController = abortControllerRef.current;
    abortController.abort();
    setFetchingAwnser(false);
    setChatHistoryLog([]);
    window.sessionStorage.setItem('conversationId', null);
    startConversation();
    abortControllerRef.current = new AbortController();
  };

  const logout = function () {
    const abortController = abortControllerRef.current;
    abortController.abort();
    window.localStorage.removeItem('password');
    window.sessionStorage.setItem('conversationId', null);
    setChatHistoryLog([]);
    setConversationId(null);
    setFetchingAwnser(false);
    abortControllerRef.current = new AbortController();
  }

  return (
    conversationStarted ? 
      <>
        <Header clearChatLog={() => clearChatLog()} logout={() => logout()} />
        <ChatArea chatLog={chatHistoryLog} fetchingAwnser={fetchingAwnser} />
        <Prompt updateChatLog={setChatHistoryLog} chatlog={chatHistoryLog} setIsLoading={setFetchingAwnser} isLoading={fetchingAwnser} signal={abortControllerRef.current.signal} />
      </> 
      :
      <>
        <Login setConversationId={setConversationId}></Login>
      </>
  );
}

export default App;
